export default {
    bind: function(el, binding, vnode) {
      el.onBlur = function(event) {
          vnode.context[binding.expression](event.target);
      };
      el.addEventListener("blur", el.onBlur, true);
    },
    unbind: function(el) {
      el.removeEventListener("blur", el.onBlur);
    }
  };